import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import {MatDialogModule} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import { HomeFiltersComponent } from './home-filters/home-filters.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '@app/@shared/shared.module';
import { ListaLinksHomeComponent } from './lista-links-home/lista-links-home.component';
import { SafeUrlPipe } from './lista-links-home/safe-url.pipe';
import { RouterModule } from '@angular/router';
import { InvestmentCalculatorComponent } from './investment-calculator/investment-calculator.component';

@NgModule({
  declarations: [
    HomeComponent,
    HomeFiltersComponent,
    ListaLinksHomeComponent,
    SafeUrlPipe,
    InvestmentCalculatorComponent
  ],
  imports: [
      CommonModule,
      MatDialogModule,
      TranslateModule,
      ReactiveFormsModule,
      MatAutocompleteModule,
      SharedModule,
      RouterModule
  ]
})
export class HomeModule { }
